import { useEffect, useState } from "react";

const useIsMobile = () => {

    const getIsMobile = () => (
        typeof window !== "undefined" ? window.innerWidth < 1024 : false
    );

    const [isMobile, setIsMobile] = useState(getIsMobile);

    useEffect(() => {

        const checkIsMobile = () => setIsMobile(getIsMobile());

        checkIsMobile();

        window.addEventListener('resize', checkIsMobile);

        return () => window.removeEventListener('resize', checkIsMobile);
        
    }, []);

    return isMobile;

};

export default useIsMobile;
